import ExtendableError from 'es6-error';

class ApiError extends ExtendableError {
  constructor(data, message = 'An unexpected error occurred, please try again.') {
    super(message);
    this.name = 'API Error';
    this.data = data;
  }
}

export default ApiError;
